import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { SubHeader } from "../../../../components/SubHeader";
import { useSite } from "../../../../contexts/Site";
import { PAGES_PATH, useCurrentPage } from "../../../../hooks/CurrentPage";
import { getPageSections } from "../../../../model/pages";
import { Site } from "../../../../model/site";
import CreationProgress from "../../components/CreationProgress";
import { AddSectionModal } from "./components/AddSectionModal";
import { EmptyState } from "./components/EmptyState";
import SectionsList from "./components/SectionsList";
import { navigationState } from "./navigationState";
import { Container } from "./styles";

/**
 * The sections of the home or of a page (?page), reached from the Keepo's pages and going back there, creating it
 * or editing it once published: the pages are the editor's way in and out.
 */
const SectionsPage = () => {
  const { t } = useTranslation();

  const { site } = useSite();
  const { pageId, page } = useCurrentPage();
  const copySite = { ...site } as Site;
  // the page being edited (?page), or the home
  const sections = getPageSections(copySite, pageId);

  const [showAddSectionModal, setShowAddSectionModal] = useState(false);

  useEffect(() => {
    navigationState.reset();
  });

  return (
    <Container>
      {/* where the person is in the flow, on top; the screen's own header under it */}
      <CreationProgress step="sections" />
      <SubHeader
        // which page is being edited, the home too ("Editando a página: Início")
        title={t("pages.editor.pageNotice.editing", { title: page ? page.title : t("pages.editor.pages.home") })}
        // back to its pages: going there isn't leaving the editor (no "discard the changes")
        crumbs={[{ label: t("pages.editor.pages.title"), to: PAGES_PATH }]}
      />
      {sections.length === 0 ? <EmptyState onClick={() => setShowAddSectionModal(true)} /> : <SectionsList />}
      {showAddSectionModal && <AddSectionModal onClose={() => setShowAddSectionModal(false)} />}
    </Container>
  );
};

export default SectionsPage;
